import { Q } from '@nozbe/watermelondb';
import { useIsFocused } from '@react-navigation/native';
import { isToday } from 'date-fns';
import React, { memo, useEffect, useState } from 'react';

import { useSyncContext } from '@/contexts/syncContext';
import { database } from '@/database';
import type { FormModel } from '@/database/model/Form';
import type { InterviewModel } from '@/database/model/Interview';
import type { IRawInterview, ISyncList } from '@/libs/types/sync';
import { List } from '@/screens/Sync/components/List';

function PendingComponent() {
  const isFocused = useIsFocused();
  const { isSyncing } = useSyncContext();

  const [unSync, setUnSync] = useState<ISyncList[]>([]);

  useEffect(() => {
    const checkSyncData = async () => {
      const interviews = await database
        .get<InterviewModel>('interviews')
        .query();
      const interviewsData = interviews.filter(
        (interview) =>
          interview.syncStatus !== 'synced' &&
          isToday(new Date(interview.created_at)),
      );
      const unSyncData = await Promise.all(
        interviewsData.map(async (interview) => {
          const form = await database
            .get<FormModel>('forms')
            .query(
              Q.and(
                Q.where('form_id', interview.form_id),
                Q.where('form_version', interview.form_version),
              ),
            )
            .fetch();
          return {
            // eslint-disable-next-line no-underscore-dangle
            ...(interview._raw as IRawInterview),
            form_name: form[0]?.name,
          };
        }),
      );
      setUnSync(
        unSyncData.filter((interview) => {
          // eslint-disable-next-line no-underscore-dangle
          if (interview._status === 'synced') {
            return interview.interview_id !== 0;
          }
          return interview;
        }),
      );
    };

    checkSyncData();
  }, [isFocused, isSyncing]);

  return <List data={unSync} />;
}

export const Pending = memo(PendingComponent);
